import { Badge } from '@/components/ui/Badge';
import { Icon } from '@/components/ui/Icon';
import { cn } from '@/utils/utils';
import type { LucideIcon } from 'lucide-react';

type ButtonCardProps = {
  label: string;
  icon: LucideIcon;
  isNew?: boolean;
  className?: string;
};

const ButtonCard = ({ label, icon, isNew, className }: ButtonCardProps) => {
  return (
    <div
      className={cn(
        'flex flex-col relative items-start justify-between p-4 gap-2 rounded-xl border cursor-pointer duration-150 ease-in transition-border border-border hover:bg-popover-hover/40 dark:hover:bg-popover-hover shadow-sm bg-popover',
        className,
      )}
    >
      <Icon size="sm" as={icon} />
      <div className="flex gap-2 items-center">
        <p className="text-sm font-medium leading-[17px]">{label}</p>
        {isNew && <Badge variant="new">NEW</Badge>}
      </div>
    </div>
  );
};
export default ButtonCard;
